import { makeAutoObservable } from 'mobx'
import { type IResponseUserAccessRequest } from 'entities/Users/api/types'
import { type UserAccessRequestType, type Permissions, type EnumUserRoles } from 'entities/Users'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'

class AccessRequestUser {
  id: number
  firstName: string
  lastName: string
  fullName: string
  photoUrl: string
  email: string
  role: EnumUserRoles
  roleLabel: string
  requestOn?: string
  createdAt?: string
  permissions: Permissions | null = null
  useOrganizationSettings: boolean
  isAway: boolean

  constructor(user: IResponseUserAccessRequest['user']) {
    this.id = user.id
    this.firstName = user.first_name
    this.lastName = user.last_name
    this.fullName = user.full_name
    this.photoUrl = user.photo_url
    this.email = user.email
    this.createdAt = user.created_at
    this.role = user.role
    this.roleLabel = user.role_label
    this.requestOn = user.request_on
    this.permissions = user.permissions
    this.useOrganizationSettings = user.use_organization_settings ?? false
    this.isAway = !!user.is_away

    makeAutoObservable(this)
  }

  get avatarInfo() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      image: this.photoUrl,
      color: getUserAvatarColor(this.id),
    }
  }

  get hasCustomPermissions() {
    return this.permissions !== null
  }
}

export class AccessRequest {
  id: number
  userId: number | null
  organizationId: number
  requestType: UserAccessRequestType
  user: AccessRequestUser
  retryCount: number
  createdAt: string
  updatedAt: string

  constructor(item: IResponseUserAccessRequest) {
    this.id = item.id
    this.userId = item.user_id
    this.organizationId = item.organization_id
    this.requestType = item.request_type
    this.retryCount = item.retry_count
    this.createdAt = item.created_at
    this.updatedAt = item.updated_at

    this.user = new AccessRequestUser(item.user)

    makeAutoObservable(this)
  }
}
